// Global brand configuration store + runtime application.
export const DEFAULT_BRAND = {
  brand_name: "Vagabondaggio Selvaggio",
  logo: "",
  favicon: "",
  colors: { orange: "#F28C45", green: "#008C5A", mint: "#EAF4F0", bg: "#F7F3E9", text: "#1A3329", peach: "#FFD9B3" },
  heading_font: "Playfair Display",
  body_font: "Nunito",
  og_image: "",
  seo_title_suffix: "Vagabondaggio Selvaggio",
  seo_description: "Viaggi autentici, intelligenti e in autonomia: itinerari testati, budget reali e strumenti per viaggiare meglio spendendo meno.",
  default_cta_label: "Scarica la guida gratuita",
  default_cta_link: "/organizza-il-tuo-viaggio",
};

export const HEADING_FONTS = ["Playfair Display", "Fraunces", "Lora", "Cormorant Garamond", "Poppins"];
export const BODY_FONTS = ["Nunito", "Inter", "Poppins", "Work Sans", "Mulish"];

export let brandCache = { ...DEFAULT_BRAND };

const brandListeners = new Set();
export function subscribeBrand(cb) { brandListeners.add(cb); return () => brandListeners.delete(cb); }
export function getBrandSnapshot() { return brandCache; }

function hexToRgbChannels(hex) {
  if (!hex) return null;
  const m = hex.replace("#", "").match(/^([0-9a-f]{6})$/i);
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}

function darken(hex, amt = 20) {
  const c = hexToRgbChannels(hex);
  if (!c) return hex;
  const [r, g, b] = c.split(" ").map(Number);
  const d = (x) => Math.max(0, x - amt);
  return `${d(r)} ${d(g)} ${d(b)}`;
}

let fontsInjected = "";

export function applyBrand(b) {
  brandCache = {
    ...DEFAULT_BRAND, ...b,
    colors: { ...DEFAULT_BRAND.colors, ...(b?.colors || {}) },
  };
  brandListeners.forEach((l) => { try { l(); } catch (e) {} });
  const root = document.documentElement;
  const c = brandCache.colors;
  const setVar = (name, hex) => {
    if (!hex) return;
    root.style.setProperty(`--vs-${name}`, hex);
    const ch = hexToRgbChannels(hex);
    if (ch) root.style.setProperty(`--vs-${name}-rgb`, ch);
  };
  setVar("orange", c.orange);
  setVar("green", c.green);
  setVar("mint", c.mint);
  setVar("bg", c.bg);
  setVar("text", c.text);
  setVar("peach", c.peach);
  if (c.orange) root.style.setProperty("--vs-orange-dark-rgb", darken(c.orange, 24));
  if (c.green) root.style.setProperty("--vs-green-deep-rgb", darken(c.green, 24));

  // Favicon
  if (brandCache.favicon) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
    link.href = brandCache.favicon;
  }

  // Fonts (inject Google Fonts + override families)
  const hf = brandCache.heading_font || DEFAULT_BRAND.heading_font;
  const bf = brandCache.body_font || DEFAULT_BRAND.body_font;
  const key = `${hf}|${bf}`;
  if (key !== fontsInjected) {
    fontsInjected = key;
    const fam = [hf, bf].filter((v, i, a) => a.indexOf(v) === i)
      .map((f) => `family=${f.replace(/ /g, "+")}:wght@400;500;600;700;800;900`).join("&");
    let fl = document.getElementById("vs-brand-fonts");
    if (!fl) { fl = document.createElement("link"); fl.id = "vs-brand-fonts"; fl.rel = "stylesheet"; document.head.appendChild(fl); }
    fl.href = `https://fonts.googleapis.com/css2?${fam}&display=swap`;
    let st = document.getElementById("vs-brand-font-style");
    if (!st) { st = document.createElement("style"); st.id = "vs-brand-font-style"; document.head.appendChild(st); }
    st.innerHTML = `body{font-family:'${bf}',system-ui,sans-serif;} .font-serif,.font-display{font-family:'${hf}',Georgia,serif;}`;
  }
}
